'use client';

import React, { useState } from 'react';

import { H1 } from '@repo/ui-kit/components/core/Typography';

import { FlexColumn } from 'styles/layouts';

import { ComponentContainer, ComponentWrapper } from '../shared/styles';

import { FrequentlyAskedQuestionItem } from './FrequentlyAskedQuestionItem';
import { Background, TwoColumnsContainer, OneColumnContainer } from './styles';
import { FrequentlyAskedQuestionsProps } from './types';

const title = 'Frequently Asked Questions';

export const FrequentlyAskedQuestions: React.FC<
  FrequentlyAskedQuestionsProps
> = ({ items, variation = 'oneColumn' }) => {
  const Container =
    variation === 'oneColumn' ? OneColumnContainer : TwoColumnsContainer;

  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <Background>
      <ComponentWrapper>
        <ComponentContainer>
          <Container>
            <H1 bold as="h2">
              {title}
            </H1>
            <FlexColumn gap="24px" width="100%">
              {items?.map((item, index) => (
                <FrequentlyAskedQuestionItem
                  key={item.title}
                  isOpen={openIndex === index}
                  text={item.text}
                  title={item.title}
                  onOpen={() =>
                    openIndex === index
                      ? setOpenIndex(null)
                      : setOpenIndex(index)
                  }
                />
              ))}
            </FlexColumn>
          </Container>
        </ComponentContainer>
      </ComponentWrapper>
    </Background>
  );
};
